import type { Pagination } from 'models';
import { generateQueryKey } from 'query';
import type { NodeOrganizationsListFilter } from './useNodeOrganizationsInfiniteQuery';
import type { OrganizationAdminsFilter } from './useOrganizationAdminsInfiniteQuery';
import type { OrganizationsListFilter } from './useOrganizationsInfiniteQuery';

type NodeOrganizationsParams = {
  filter?: Partial<NodeOrganizationsListFilter>;
  pagination?: Partial<Pagination>;
};

type OrganizationAdminsParams = {
  filter?: Partial<OrganizationAdminsFilter>;
  pagination?: Partial<Pagination>;
};

type OrganizationsParams = {
  filter?: OrganizationsListFilter;
  pagination?: Partial<Pagination>;
};
// TODO: split organizations
export const getPublicOrganizationsInfiniteQueryKey = ({ filter = {}, pagination = {} }: OrganizationsParams) =>
  generateQueryKey(['organizations', 'public', { filter, pagination }, 'infinite']);

export const getOrganizationsInfiniteQueryKey = ({ filter = {}, pagination = {} }: OrganizationsParams) =>
  generateQueryKey(['organizations', { filter, pagination }, 'infinite']);

export const getOrganizationDetailQueryKey = ({ organizationId }: { organizationId?: string }) =>
  generateQueryKey(['organizations', 'detail', { id: organizationId }]);

export const getOrganizationAdminsInfiniteQueryKey = ({ filter, pagination }: OrganizationAdminsParams) =>
  generateQueryKey(['organizations', 'admins', { filter, pagination }]);

export const getNodeOrganizationsInfiniteQueryKey = ({ filter, pagination }: NodeOrganizationsParams) =>
  generateQueryKey(['organizations', 'node', { filter, pagination }, 'infinite']);
